module.exports = __webpack_public_path__ + "static/media/rental-counter-mobile.62de1441.jpg";